import {
  PRESUPUESTADOR_GET_COTIZACION_BEGIN,
  PRESUPUESTADOR_GET_COTIZACION_SUCCESS,
  PRESUPUESTADOR_GET_COTIZACION_FAILURE,
  PRESUPUESTADOR_GET_COTIZACION_DISMISS_ERROR,
} from './constants'
import axios from 'axios'
import { REACT_APP_COTIZADOR_API } from '../../../common/config'
import validatePatente from '../../common/backend/validatePatente'
import { BFFAgent } from '../../../common/BFFAgent'
import { PATENTE_LOCKED } from 'presupuestador/lib/constants'

 // Era 0.96  -----  Se baja un 4% para considerar posibles gastos
 const MULTIPLICADOR_COTIZACION = 1
 
export function getCotizacion(params) {
  const { year, kilometraje, matricula, brand, brandId, model, modelId, version, versionId } = params
  return (dispatch, getState) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: PRESUPUESTADOR_GET_COTIZACION_BEGIN,
      data: params,
      patente: matricula,
    })

    const { presupuestador } = getState()

    return new Promise((resolve, reject) => {
      // Armo el body para la consulta
      const body_cotizador = {
        costs: [
          {
            type: 'general',
            amount: 0,
          },
          {
            type: 'cubiertas',
            amount: 0,
          },
        ],
        interior: 5, // 10: excelente, 5: bueno, 0: malo
        kms: kilometraje,
        licencePlate: matricula,
        vehicle: {
          brand: brandId,
          brandName: brand,
          model: modelId,
          modelName: model,
          version: versionId,
          versionName: version,
          year: year,
        },
      }
      // Valido la patente
      if (matricula) {
        const valid = validatePatente(matricula)
        if (valid) {
          const existePatente = presupuestador.entregaUsados.some((item) => item.patente === matricula)
          if (existePatente) {
            dispatch({ 
              type: PRESUPUESTADOR_GET_COTIZACION_FAILURE,
              data: { error: 'La patente ya existe', ...params },
              patente: matricula,
            })
            reject({
              message: 'La patente ya existe',
            })
          } else {
            const patenteBloqued = BFFAgent.Peritador.getLockedPatent(matricula)
            patenteBloqued.then( result =>{
              if (result.locked) {
                dispatch({
                  type: PRESUPUESTADOR_GET_COTIZACION_FAILURE,
                  data: {
                    error: PATENTE_LOCKED,
                    patenteCodeError:{
                      code: 'patenteBloqueada',
                      message: PATENTE_LOCKED
                    },
                    ...params },
                  patente: matricula,
                })
              } else {
                const doRequest = axios.post(REACT_APP_COTIZADOR_API + '/cotizador/v1/quotes', body_cotizador)
                doRequest.then (
                  (res) => {
                    dispatch({
                      type: PRESUPUESTADOR_GET_COTIZACION_SUCCESS,
                      data: res.data,
                      patente: matricula,
                      params: params
                    })
                    resolve(res)
                  },
                  () => {
                    dispatch({
                      type: PRESUPUESTADOR_GET_COTIZACION_FAILURE,
                      data: { error: 'El vehículo no se encuentra segmentado', ...params },
                      patente: matricula,
                    })
                    reject({
                      message: 'El vehículo no se encuentra segmentado',
                    })
                  },
                )
              }
            })
          }
        } else {
          dispatch({
            type: PRESUPUESTADOR_GET_COTIZACION_FAILURE,
            data: { 
              error: 'La patente es inválida',
              patenteCodeError:{
                code: 'invalid',
                message: 'Ingresá una patente válida'
              },
              ...params },
            patente: matricula,
          })
        }
      } else {
        const doRequest = axios.post(REACT_APP_COTIZADOR_API + '/cotizador/v1/quotes', body_cotizador)
        doRequest.then(
          (res) => {
            dispatch({
              type: PRESUPUESTADOR_GET_COTIZACION_SUCCESS,
              data: res.data,
              patente: matricula,
              params: params
            })
            resolve(res)
          },
          () => {
            dispatch({
              type: PRESUPUESTADOR_GET_COTIZACION_FAILURE,
              data: { error: 'El vehículo no se encuentra segmentado', ...params },
              patente: matricula,
            })
            reject({
              message: 'El vehículo no se encuentra segmentado',
            })
          },
        )
      }
    })
  }
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetCotizacionError() {
  return {
    type: PRESUPUESTADOR_GET_COTIZACION_DISMISS_ERROR,
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case PRESUPUESTADOR_GET_COTIZACION_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getCotizacionPending: true,
        getCotizacionError: null,
      }

    case PRESUPUESTADOR_GET_COTIZACION_SUCCESS: {
      // The request is success
      const precioEstimado = action.data.quote.prices.filter((price) => price.type === 'estimated')
      const searchPendingQuote = (patente) => {
        const pendingQuotes = state.solicitudPendiente;
        let isPending = false;
        for (let pendingQuote of Object.keys(pendingQuotes)) {
          if (String(patente.toLowerCase()) == String(pendingQuote.toLowerCase())) {
            isPending = pendingQuotes[pendingQuote]
          }
        }
        return isPending;
      }
     
      return {
        ...state,
        cotizaciones: state.cotizaciones.concat(action.data),
        entregaUsados:[
          {
            final_take_price: precioEstimado[0].amount * MULTIPLICADOR_COTIZACION,
            original_price: precioEstimado[0].amount * MULTIPLICADOR_COTIZACION,
            peritado: searchPendingQuote(action.params.matricula) ? true : false,
            ...action.params,
            quotation_id: action.data.id,
            km: action.params.kilometraje,
            valid: true,
            pending: false,
            error: null,
            patente: action.params.matricula,
            requestsId: searchPendingQuote(action.params.matricula),
            request_id: searchPendingQuote(action.params.matricula),
          },
        ].concat(state.entregaUsados),
        getCotizacionPending: false,
        getCotizacionError: null,
        buscarAutoEntrega: false
      }}

    case PRESUPUESTADOR_GET_COTIZACION_FAILURE:
      // The request is failed
      return {
        ...state,
        getCotizacionPending: false,
        getCotizacionError: action.data.error,
        patenteCodeError: action.data.patenteCodeError
      }

    case PRESUPUESTADOR_GET_COTIZACION_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getCotizacionPending: false,
        getCotizacionError: null,
      }

    default:
      return state
  }
}
